import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { FlagDescriptions } from '../../../../shared/featureFlags/types';

function getAllFeatureFlags() {
  return get<{flags: FlagDescriptions }>('/api/feature_flags');
}

/**
 * Helper hook for fetching feature flags for the admin page.
 * @returns A list of feature flags
 */
export default function useGetAllFeatureFlags() {
  return useQuery<{flags: FlagDescriptions }>({
    queryFn: () => getAllFeatureFlags(),
    queryKey: ['all-feature-flags'],
  });
}
